/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValidateTokenResponse
 */
export interface ValidateTokenResponse {
    /**
     * True if token is genuine and has not expired yet, false otherwise.
     * @type {boolean}
     * @memberof ValidateTokenResponse
     */
    valid: boolean;
    /**
     * If the token is invalid, this field contains the reason.
     * @type {string}
     * @memberof ValidateTokenResponse
     */
    invalidity_reason?: ValidateTokenResponseInvalidityReasonEnum;
    /**
     * JWT token validity. This value is not present if the token is not valid (valid field == false).
     * @type {number}
     * @memberof ValidateTokenResponse
     */
    expires_in_seconds?: number;
    /**
     * Token expiration time in UTC. This value is not present if token is not valid (valid field == false) or expired.
     * @type {Date}
     * @memberof ValidateTokenResponse
     */
    expires_at?: Date;
}


/**
 * @export
 */
export const ValidateTokenResponseInvalidityReasonEnum = {
    InvalidTokenContent: 'invalid_token_content',
    Expired: 'expired',
    InvalidIssuer: 'invalid_issuer',
    NotEnoughFactors: 'not_enough_factors',
    PersonNotActive: 'person_not_active'
} as const;
export type ValidateTokenResponseInvalidityReasonEnum = typeof ValidateTokenResponseInvalidityReasonEnum[keyof typeof ValidateTokenResponseInvalidityReasonEnum];


/**
 * Check if a given object implements the ValidateTokenResponse interface.
 */
export function instanceOfValidateTokenResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "valid" in value;

    return isInstance;
}

export function ValidateTokenResponseFromJSON(json: any): ValidateTokenResponse {
    return ValidateTokenResponseFromJSONTyped(json, false);
}

export function ValidateTokenResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidateTokenResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'valid': json['valid'],
        'invalidity_reason': !exists(json, 'invalidity_reason') ? undefined : json['invalidity_reason'],
        'expires_in_seconds': !exists(json, 'expires_in_seconds') ? undefined : json['expires_in_seconds'],
        'expires_at': !exists(json, 'expires_at') ? undefined : (new Date(json['expires_at'])),
    };
}

export function ValidateTokenResponseToJSON(value?: ValidateTokenResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'valid': value.valid,
        'invalidity_reason': value.invalidity_reason,
        'expires_in_seconds': value.expires_in_seconds,
        'expires_at': value.expires_at === undefined ? undefined : (value.expires_at.toISOString()),
    };
}

